import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { hasAnonymization } from '@collections/users';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { editDashboardTask, editTask, Task, TasksAddEditService } from 'mojo-tasks';
import { getFormat, getDate } from '@shared';

@Component({
  selector: 'mojo-edit-task-item',
  templateUrl: './edit-task-item.component.html',
  styleUrls: ['./edit-task-item.component.scss'],
})
export class EditTaskItemComponent implements OnInit, OnDestroy {
  @Input() task: Task;
  @Input() isDashboard = false;
  @Input() hasAnonymization = false;
  getFormat = getFormat;
  getDate = getDate;
  hasAnonymization$ = this.store.select(hasAnonymization);
  longName: string;
  disabledToolTip = true;
  userInput: UntypedFormControl = new UntypedFormControl(null);
  form = this.fb.group({
    id: [null],
    description: ['', [Validators.required, Validators.minLength(1)]],
    date: [null, Validators.required],
    userInput: this.userInput,
  });

  today = new Date();
  subs = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private cdr: ChangeDetectorRef,
    public talentPoolsService: TalentPoolsService,
    private tasksAddEditService: TasksAddEditService,
  ) {}

  ngOnInit(): void {
    const formattedDescription = this.task.description
      .split('\n')
      .map((line) => (line !== '' ? `<p>${line}</p>` : '<p></br></p>'))
      .join('');
    const date = new Date(this.task.dueDate);
    this.form.patchValue(
      {
        id: this.task.id,
        description: formattedDescription,
        date: this.getDate(date),
        userInput: { id: this.task.assignedUserId, name: this.task.assignedUser },
      },
      { emitEvent: false },
    );
    this.cdr.detectChanges(); // Without this, there are strange errors in unit tests
    this.form.controls.date.setErrors(null); // We need this to allow editing tasks with past date

    this.subs.add(
      this.form.controls.date.valueChanges.subscribe((val: Date) => {
        const date = new Date(val);
        this.form.patchValue(
          {
            date: this.getDate(date),
          },
          { emitEvent: false },
        );
      }),
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  confirmEdit() {
    const task: Partial<Task> = {
      id: this.form.value.id,
      description: this.form.value.description.replace(/(\r\n|\n|\r)/gm, ' '),
      dueDate: this.form.value.date,
      assignedUserId: this.userInput.value?.id,
    };
    this.tasksAddEditService.cancelAnyTaskMode();
    if (this.isDashboard) {
      this.store.dispatch(editDashboardTask({ payload: task }));
    } else {
      this.store.dispatch(editTask({ payload: task, anonymization: this.hasAnonymization }));
    }
  }

  cancelEdit() {
    this.tasksAddEditService.cancelAnyTaskMode();
  }

  getName() {
    if (this.userInput.value?.name) {
      if (this.userInput.value?.name.length > (this.isDashboard ? 4 : 8)) {
        this.longName = this.userInput.value?.name;
        this.disabledToolTip = false;
      } else {
        this.disabledToolTip = true;
      }
      return this.userInput.value?.name.length > (this.isDashboard ? 4 : 8)
        ? this.userInput.value?.name.substring(0, this.isDashboard ? 4 : 8) + '...'
        : this.userInput.value?.name;
    } else {
      return 'Assign';
    }
  }
}
